

















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import { SET_ACTIVE_FILTER } from "@/store/mutation-types";

@Component({
  computed: {
    ...mapState("projects", ["activeFilter"]),
  },
})
export default class UcFilter extends Vue {
  @Prop({ required: true })
  data!: [string, number];

  @Prop({ required: true })
  label!: string;

  @Prop()
  source!: [];

  setFilter(value: string) {
    if (!this.source.length) return;
    this.$store.commit(`projects/${SET_ACTIVE_FILTER}`, String(value));
  }
}
